import { render } from "./CadastrarTerceiro.vue?vue&type=template&id=00183a99&scoped=true"
import script from "./CadastrarTerceiro.vue?vue&type=script&lang=js"
export * from "./CadastrarTerceiro.vue?vue&type=script&lang=js"

import "./CadastrarTerceiro.vue?vue&type=style&index=0&id=00183a99&scoped=true&lang=css"
import "./CadastrarTerceiro.vue?vue&type=style&index=1&id=00183a99&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00183a99"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QBtn,QCard,QIcon,QInput,QTable,QImg,QTr,QTd,QField});
